import { useEffect, useState } from "react";
import LavorisService from "../services/LavorisService";

export function useSelectData(resource: string, usedata:boolean = true) {

  const LavorisInstance = LavorisService.getInstance();
  const [data, setData] = useState<LAVDataRow[]>([]);
  const [itemsSelected, setItemsSelected] = useState<LAVDataRow[]>([]);
  const onUnSelected = (itemUnSelected: string) => {
    const restOfItems = itemsSelected.filter(
      (practice) => practice.name !== itemUnSelected,
    );
    setItemsSelected(restOfItems);
  };

  const onSelect = (item: LAVDataRow) => {
    setItemsSelected([...itemsSelected, item]);
  };

  const fetchData = () => {
    if (usedata) {
      LavorisInstance.Common.getData(resource).then(setData).catch(console.error);
    }
    return
  };

  useEffect(
    fetchData,
    // eslint-disable-next-line
    [],
  );

  return {
    data,
    fetchData,
    helpers: {
      itemsSelected,
      setItemsSelected,
      onUnSelected,
      onSelect,
    },
  };
}
